import React from 'react';
import { Navigate, Outlet, useLocation} from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { AppLayout } from './AppLayout';
import { LoadingPage } from '../../pages/auth/LoadingPage';

/**
 * ProtectedRoute layout component that ensures user is authenticated
 * Redirects to appropriate auth pages if not authenticated
 * Renders child routes with AppHeader when authenticated
 */
export function ProtectedRoute() {
  const { isLoading, isAuthenticated, requiresNewPassword, tempUsername } = useAuth();
  const location = useLocation(); // Get the current location object

  // Show loading while checking authentication
  if (isLoading) {
    return <LoadingPage />;
  }

  // Redirect to new password page if required
  if (!isAuthenticated && requiresNewPassword && tempUsername) {
    return <Navigate to="/new-password" replace />;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to={`/login?from=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  }

  // User is authenticated - render protected content with app layout
  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
}
